import httpMethods from './httpMethods'

export const leadServiceHelper = {
    submitMobileNumberService : (data,callback)=>{
        // let apiUrl = 'https://fsvuauiwai.execute-api.ap-south-1.amazonaws.com/Prod/lead'
        let apiUrl = 'https://fsvuauiwai.execute-api.ap-south-1.amazonaws.com/Prod-added-API-Key/lead'
        httpMethods.postMethod(data,apiUrl,callback,false)
    }
}
